import { defineMessages } from 'react-intl';

export default defineMessages({
  addToCartMultipleItems: {
    id: 'Pdp.addToCartBundlePdpContainer.button.multipleItems.text',
    defaultMessage: 'Add Items to Cart',
  },
});
